import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  NumberField,
  BooleanField,
  useRecordContext,
  FunctionField,
} from 'react-admin';
import { Box, Card, CardContent, Grid, Typography, Chip } from '@mui/material';

export const BetShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <BetHeader />
        <BetDetails />
      </SimpleShowLayout>
    </Show>
  );
};

const BetHeader = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <Typography variant="h5">Bet #{record.bet_id}</Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              👤 User ID: <strong>{record.user_id}</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              🎯 Event ID: {record.event_id} | 💬 Chat ID: {record.chat_id}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              📅 {new Date(record.created_at).toLocaleString()}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <Chip label={record.token} color="primary" />
              <Chip
                label={record.is_win ? 'WIN' : 'LOSS'}
                color={record.is_win ? 'success' : 'error'}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const BetDetails = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Bet Details
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Bet Amount
            </Typography>
            <Typography variant="h5" color="primary.main">
              {record.bet_amount} {record.token}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ${record.bet_amount_usd?.toFixed(2)} USD
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              {record.is_win ? 'Win Amount' : 'Potential Win'}
            </Typography>
            <Typography
              variant="h5"
              color={record.is_win ? 'success.main' : 'text.secondary'}
            >
              ${record.win_amount_usd?.toFixed(2)} USD
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Points Earned
            </Typography>
            <Typography variant="h6">
              {record.points_earned?.toFixed(2)} points
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Result
            </Typography>
            <Typography variant="h6">
              {record.is_win ? '✅ Win' : '❌ Loss'}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Timestamp
            </Typography>
            <Typography variant="body1">
              {new Date(record.created_at).toLocaleString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              })}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
